import { useLatestRef } from '@griply/hooks';
import { UserProperties } from '@griply/types';
import { useCallback } from 'react';
import { getMixpanelService } from 'shared/services/tracking';

import { useUser } from './use-user';

export const useSetUserProperties = () => {
  const user = useUser();
  const userRef = useLatestRef(user);

  return useCallback(
    (properties: Partial<UserProperties>) => {
      getMixpanelService(userRef.current).setUserProperties(properties);
    },
    [userRef],
  );
};
